import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

export default function PowerAnything() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.PowerAnything');

    return (
        <div className={`${styles.powerAnything}`}>
            <div className="solution-item">
                <div className="text-box">
                    <div className="sub-title">{t('label')}</div>
                    <h2 className="title">{t('title')}</h2>
                    <div className="desc">{t('desc')}</div>
                </div>
                <div className="bg-img">
                    <EcoImg
                        pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717642930936/pc-tuya.jpg"
                        pad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717642920704/mo-tuya.jpg"
                        alt={t('title')}
                    />
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
